"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const PlaceholderLoading_1 = tslib_1.__importDefault(require("src/components/loadings/PlaceholderLoading"));
const Loading = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: props.wrapperClassName, style: props.wrapperStyle, children: Array.from({ length: props.count || 1 }, (_, index) => ((0, jsx_runtime_1.jsx)(PlaceholderLoading_1.default, { containerClassName: props.containerClassName, containerStyle: props.containerStyle, height: props.height }, index))) }));
};
exports.default = Loading;
